import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const Conclusion = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.Conclusion} />
    </div>
  );
};

export default Conclusion;
